<template>
    <div>
        <div class="title pa-4">预约规则配置</div>
        <div>
            <LPassRuleList single-rule :pass-rules="rules"/>
        </div>
        <div class="pa-4" style="font-size: 16px">
            最多可预约车牌总数: {{maxSize}}
        </div>
        <div style="text-align: center" class="mt-4">
            <v-btn color="primary" @click="open">修改规则</v-btn>
        </div>
        <v-dialog lazy max-width="1000" v-model="dialog.visible" persistent scrollable>
            <SetPassRuleContent
                v-if="dialog.visible"
                status="edit"
                :authority="authority"
                :rule="dialog.rule"
                @cancel="dialog.visible = false"
                @save="updateRule"
            >
                <template slot="after">
                    <div class="px-4">
                        <v-text-field v-model="maxSize" label="最多可预约车牌总数" type="number"/>
                    </div>
                </template>
            </SetPassRuleContent>
        </v-dialog>
    </div>
</template>
<script>
import LPassRuleList from "@/components/LPassRuleList.vue";
import SetPassRuleContent from "@/components/SetPassRuleContent.vue";
import axios from "axios";
import {PassRule} from "@/object";
import {handleError} from "@/store/handleError";

export default {
    name: "VehicleSelfServiceReservationConfig",
    components: {SetPassRuleContent, LPassRuleList},
    data: () => ({
        dialog: {
            visible: false,
            rule: new PassRule()
        },
        maxSize: null,
        rules: [] // 只有一个
    }),
    computed: {
        authority() {
            return this.$store.state.reservation.adminAuth
        },
        controllerList() {
            return this.$store.state.parkingLot.controllerList
        }
    },
    mounted() {
        this.refreshInfo()
    },
    methods: {
        async refreshInfo() {
            let url = '/passApi/order/visitor/config'
            try {
                let res = null
                res = await axios.get(url)
                if (res.data && +res.data.status === 1) {
                    const rule = PassRule.fromAPI(res.data.data, this.controllerList)
                    rule.active = true
                    rule.slices.forEach(s => s.active = true)
                    this.rules = [rule]
                    this.maxSize = res.data.data.maxSize
                } else {
                    throw handleError(res.data)
                }
            } catch (e) {
                this.$L.alert('error', e.message)
            } finally {
            }
        },
        open() {
            // console.log('update', this.rules[0])
            this.dialog = {
                visible: true,
                rule: this.rules[0]
            }
        },
        async updateRule({newItem: rule}) {
            // console.log('rule', rule)
            const url = '/passApi/order/visitor/config/' + this.maxSize
            try {
                if (this.maxSize == null || isNaN(this.maxSize) || this.maxSize < 0) {
                    throw new Error('请输入最大可预约车牌数')
                }
                const res = await axios.put(url, {
                    passrule: rule.toAPI('visitor'),
                    size: Number(this.maxSize),
                })
                if (res.data && +res.data.status === 1) {
                    this.refreshInfo()
                    this.$L.alert('success', '修改成功')
                } else {
                    throw handleError(res.data)
                }

            } catch (e) {
                this.$L.alert('error', e.message)
            } finally {
                this.dialog = {
                    visible: false,
                    rule: new PassRule()
                }
            }
        }
    }
}
</script>


<style scoped>

</style>
